var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Navigate } from 'react-router-dom';
import React from 'react';
import Page from './Page';
import Session from '../../services/Session';
import Routes from '../../routes/RoutesConfig';
import { ApplicationContext } from '../../ApplicationContext';
/**
 *
 */
var Loading = /** @class */ (function (_super) {
    __extends(Loading, _super);
    /**
     *
     * @param props
     */
    function Loading(props) {
        return _super.call(this, props) || this;
    }
    /**
     *
     * @return {*}
     */
    Loading.prototype.render = function () {
        if (Session.isInitialized) {
            if (!Session.isLoggedIn) {
                var deeplink = Session.getDeeplink(Session.isLoggedIn);
                if (deeplink !== Routes.ROOT.path) {
                    return React.createElement(Navigate, { to: deeplink });
                }
                else {
                    return React.createElement(Navigate, { to: Routes.LOGIN.path });
                }
            }
            else {
                return React.createElement(Navigate, { to: Routes.ASSETS.path });
            }
        }
        // Show loading page
        return React.createElement(Page, { pageName: 'loading' });
    };
    return Loading;
}(React.Component));
export default Loading;
Loading.contextType = ApplicationContext;
